<template>
  <div class="w-100">
    <div class="data" v-if="loaded">
      <h1 class="d-inline">Recommendation #{{ recommendation?.id }}</h1>
      <form action="" class="mt-4 mb-5">
        <div class="form-row">
          <div class="form-group col-lg-6">
            <label for="titleInput">Title</label>
            <input v-model="updateForm.title" class="form-control" id="titleInput" placeholder="Title" />
          </div>
        </div>


        <div class="form-row mt-2">
          <div class="form-group col-lg-4">
            <label for="priorityInput">Priority</label>
            <input v-model="updateForm.priority" class="form-control" type="number" min="1" max="20"
              id="priorityInput" />
          </div>
        </div>

        <div class="form-group ">
          <label for="statusInput">Active</label>
          <input type="checkbox" v-model="updateForm.is_enabled" class="form-control" id="statusInput"
            style="width:auto" />
        </div>

        <hr class="mt-4 mb-4" />
        <div class="form-row">
          <div class="form-group col-lg-6">
            <p class="text-primary font-weight-bold">
              If you want to show certain products select it here.
            </p>
            <h5 class="d-inline">Product List</h5>
            <v-select
                v-model="products"
                @search="fetchProducts"
                :options="productOptions"
                label="title"
                multiple
                :filterable="false"
                placeholder="Select products"
            >
              <template #no-options>
                type to search products...
              </template>
              <template #option="{ title }">
                <div>{{ title }}</div>
              </template>
              <template #selected-option="option">
                <div v-if="option">{{ `${option?.id} - ${option?.title}` }}</div>
              </template>
            </v-select>
          </div>
        </div>
        <ul style="padding-left: 20px;" class="mb-3" v-if="errors.length">
          <li v-for="error in errors" v-bind:key="error" class="text-danger">
            {{ error }}
          </li>
        </ul>


        <hr class="mt-4 mb-4" />
        <p class="text-primary font-weight-bold">
          If you want to select a collection to display, choose it here.
        </p>

        <!-- Category Selector -->
        <div class="form-row mb-3">
          <div class="form-group col-lg-6">
            <label>Categories</label>
            <v-select
              v-model="categories"
              @search="fetchCategories"
              :options="categoryOptions"
              label="title"
              multiple
              :filterable="false"
              placeholder="Select categories"
            >
              <template #no-options>
                type to search categories...
              </template>
              <template #option="{ title }">
                <div>{{ title }}</div>
              </template>
              <template #selected-option="option">
                <div v-if="option">{{ option.title }}</div>
              </template>
            </v-select>
          </div>
        </div>

        <!-- Collection Selector -->
        <div class="form-row mb-3">
          <div class="form-group col-lg-6">
            <label>Collections</label>
            <v-select
              v-model="collections"
              @search="fetchCollections"
              :options="collectionOptions"
              label="title"
              multiple
              :filterable="false"
              placeholder="Select collections"
            >
              <template #no-options>
                type to search collections...
              </template>
              <template #option="{ title }">
                <div>{{ title }}</div>
              </template>
              <template #selected-option="option">
                <div v-if="option">{{ option.title }}</div>
              </template>
            </v-select>
          </div>
        </div>

        <!-- Landing page Selector -->
        <div class="form-row mb-3">
          <div class="form-group col-lg-6">
            <label>Landing pages</label>
            <v-select
                v-model="landings"
                @search="fetchLandings"
                :options="landingOptions"
                label="title"
                multiple
                :filterable="false"
                placeholder="Select landings"
            >
              <template #no-options>
                type to search landings...
              </template>
              <template #option="{ title }">
                <div>{{ title }}</div>
              </template>
              <template #selected-option="option">
                <div v-if="option">{{ option.title }}</div>
              </template>
            </v-select>
          </div>
        </div>

        <div v-if="options.length" class="form-group col-lg-6">
          <draggable v-model="options" class="list-group product-list" :options="{ handle: '.handle' }">
            <div v-for="(product, index) in options" :key="`${product.type}-${product.id}`" class="list-group-item product-item handle">
              <i class="fas fa-arrows-alt" style="margin-left: .2rem;"></i>
              {{ product.type+ ' - '+product.id + ' - '+ product.title }}
            </div>
          </draggable>
        </div>


        <button type="submit" class="btn btn-primary mt-1 mr-2" @click="submit">Submit</button>
        <button type="button" class="btn btn-info ml-2 pl-3 pr-3 mt-3 mb-3" title="Edit" @click="showTranslator(id)">
          Add translation <i class="fa fa-language"></i>
        </button>
      </form>

    </div>

    <div class="mt-5 pt-5">
      <loading v-if="!loaded"></loading>
    </div>

    <translator
        ref="translator"
        :keys="translateKeys"
        model="Recommendation"
        :model_id="modelID"
    >

    </translator>
  </div>
</template>

<script>
import axios from "axios";
import { config } from "../../helpers";
import VueSelect from "vue-select";
import 'vue-select/dist/vue-select.css';
import draggable from 'vuedraggable'
import { getLanguages } from "@/config/languages";
import Translator from "@/components/Translator.vue";


export default {
  name: "Recommendation",
  components: {
    Translator,
    'v-select': VueSelect,
    draggable,
  },
  data() {
    return {
      id: this.$route.params.id,
      loaded: false,
      recommendation: null,
      products: [],
      productOptions: [],
      options: [],
      tags:null,
      selectedTags:[],
      updateForm: {
        is_enabled: true,
        priority: 1,
      },
      errors: [],

      selectedCity: null,
      selectedAttribute: null,
      collections: [],
      collectionOptions: [],
      categories: [],
      categoryOptions: [],
      cityOptions: [],
      landings: [],
      landingOptions: [],
      translateKeys: [
        {
          "key" : "title",
          "type": "text",
        },
      ],
      modelID: 0,


      debouncedFetchProducts : _.debounce((search, loading) => {
        loading(true);

        const params = {};
        params['filters[title]'] = search;
        params['available'] = 1;

        axios.get(config("BACKEND_ROOT") + "/admin/products", { params: params }).then((response) => {
          this.productOptions = response.data.data;
          loading(false);
        });
      }, 350), // Set a delay of 350 milliseconds

      debouncedFetchCollections: _.debounce((search, loading) => {
        loading(true);
        axios
          .get(config("BACKEND_ROOT") + "/admin/collections", {
            params: { 'filters[title]': search },
          })
          .then((response) => {
            this.collectionOptions = response.data.data;
            loading(false);
          });
      }, 350),

      debouncedFetchCategories: _.debounce((search, loading) => {
        loading(true);
        axios
          .get(config("BACKEND_ROOT") + "/admin/categories", {
            params: { 'filter[title]': search },
          })
          .then((response) => {
            this.categoryOptions = response.data.data;
            loading(false);
          });
      }, 350),

      debouncedFetchCities: _.debounce((search, loading) => {
        loading(true);
        axios.get(config("BACKEND_ROOT") + "/cities", {
          params: { 'q': search }
        }).then((response) => {
          this.cityOptions = response.data.data;
          loading(false);
        }).catch(() => loading(false));
      }, 350),

      debouncedFetchLandings: _.debounce((search, loading) => {
        loading(true);
        axios
            .get(config("BACKEND_ROOT") + "/admin/landing-pages", {
              params: { 'filters[title]': search },
            })
            .then((response) => {
              this.landingOptions = response.data.data;
              loading(false);
            });
      }, 350),

    };
  },

  mounted() {
    this.url = config("BACKEND_ROOT") + "/admin/recommendations";
    this.loadData();
  },

  watch: {
    products: {
      deep: true,
      handler(newVal) {
        // حذف همه product های قبلی از options
        if(this.options.length) {
          this.options = this.options.filter(o => o.type !== 'product');
        }

        // اضافه کردن محصولات جدید
        newVal.forEach(item => {
          this.options.push({
            type: 'product',
            id: item.id,
            title: item.title
          });
        });
      }
    },
    categories: {
      deep: true,
      handler(newVal) {
        this.options = this.options.filter(o => o.type !== 'category');
        newVal.forEach(item => {
          this.options.push({
            type: 'category',
            id: item.id,
            title: item.title
          });
        });
      }
    },

    collections: {
      deep: true,
      handler(newVal) {
        this.options = this.options.filter(o => o.type !== 'collection');
        newVal.forEach(item => {
          this.options.push({
            type: 'collection',
            id: item.id,
            title: item.title
          });
        });
      }
    },

    landings: {
      deep: true,
      handler(newVal) {
        this.options = this.options.filter(o => o.type !== 'landingPage');
        newVal.forEach(item => {
          this.options.push({
            type : 'landingPage',
            id   : item.id,
            title: item.title
          });
        });
      }
    }
  },

  methods: {
    loadData() {
      if (this.id) {
        axios.get(`${this.url}/${this.id}`).then((response) => {
          this.recommendation = response.data.data;
          this.updateForm = JSON.parse(JSON.stringify(response.data.data));
          this.products = this.mapFromRecommendationProducts(this.recommendation.products);
          this.categories = this.mapFromRecommendationData(this.recommendation.categories);
          this.collections = this.mapFromRecommendationData(this.recommendation.collections);
          this.landings = this.mapFromRecommendationData(this.recommendation.landings);

        });
      }

      this.loaded = true;
    },

    showTranslator(model_id){
      this.modelID = parseInt(model_id);
      this.$refs.translator.showTranslateModal();
    },

    fetchProducts(search, loading) {
      // Call the debounced function
      this.debouncedFetchProducts(search, loading);
    },

    fetchCollections(search, loading) {
      if (search.length) {
        this.debouncedFetchCollections(search, loading);
      }
    },
    fetchLandings(search, loading) {
      if (search.length) {
        this.debouncedFetchLandings(search, loading);
      }
    },

    fetchCategories(search, loading) {
      if (search.length) {
        this.debouncedFetchCategories(search, loading);
      }
    },

    fetchCategoryObjectsBySlugs(slugs) {
      axios
        .get(config("BACKEND_ROOT") + "/all-categories", {
          params: {
            'filter[slug]': slugs.join(','),
          },
        })
        .then((response) => {
          this.categories = response.data.data; // ensure these have `slug` and `title`
        });
    },

    submit(event) {
      event.preventDefault();

      const data = {
        title: this.updateForm.title,
        priority: this.updateForm.priority,
        is_enabled: this.updateForm.is_enabled,
        options: this.mapToRecommendationProducts(this.options),
      }

      const req = this.id ? axios.put(this.url + "/" + this.id, data) : axios.post(this.url, data);

      req.then(() => {
            this.$router.push('/recommendations')
          });
    },

    resetForm(event) {
      event.preventDefault();
      this.updateForm = { ...this.recommendation };
    },


    mapFromRecommendationProducts(products) {
      return products
        .map((product) => {
          return {
            id: product.id,
            title: product.title,
            location: product.location,
          }
        });
    },
    mapFromRecommendationData(products) {
      return products
        .map((product) => {
          return {
            id: product.id,
            title: product.title,
          }
        });
    },

    mapToRecommendationProducts(products) {
      return products.map((product, index) => {
        return {
          id: product.id,
          type: product.type,
          priority: index + 1,
        }
      });
    },

  },
};
</script>

<style>
.product-item {
  cursor: pointer;
  background-color: lightgrey !important;
  margin-top: 0.5rem;
}

.product-list {
  padding: .5rem;
  margin-bottom: .5rem;
}
</style>